import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StringFormControl } from '@lc/core';
import { MatFormField, MatLabel, MatHint, MatError } from '@angular/material/input';
import { InputField } from '../../input-field';
import { EditorControlComponent } from '../editor-control/editor-control.component';

@Component({
  selector: 'lc-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextEditorComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TextEditorComponent),
      multi: true,
    },
  ],
  imports: [
    MatFormField,
    MatLabel,
    EditorControlComponent,
    FormsModule,
    ReactiveFormsModule,
    MatHint,
    MatError,
  ],
})
export class TextEditorComponent extends InputField {
  @Input()
    label: string;

  @Input()
    placeholder = '';

  @Input()
    hint: string;

  @Input()
    suffix: string;

  @Input()
    readonly: boolean;

  @Output()
  readonly change = new EventEmitter<void>();

  @Output()
  readonly blur = new EventEmitter<void>();

  public onBlur() {
    if (this.formControl && this.formControl instanceof StringFormControl) {
      this.formControl.onLostFocus();
    }

    this.blur.emit();
    this.executeOnTouched();
  }

  public onTextChange(value) {
    this.value = value;
    this.executeOnChanged();
  }
}
